import {Suspense} from 'react';
import environmentStore, {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import HomeContentsEu from '@di-shared/features/home/eu/HomeContents.eu';
import HomeContentsKr from '@di-shared/features/home/kr/HomeContents.kr';
import HomeContentsNa from '@di-shared/features/home/na/HomeContents.na';
import {RegionType} from '@shared/cci/features/const/environment';

export interface HomePageProps {
  vin: string;
}

function HomePage({vin}: HomePageProps) {
  const region = useEnvironmentStore((state) => state.region);
  const puid = environmentStore.getState().puid;
  const ccid = environmentStore.getState().ccid;
  return region === RegionType.KR ? (
    <Suspense>
      <HomeContentsKr
        vin={vin}
        puid={puid}
        ccid={ccid}
      />
    </Suspense>
  ) : region === RegionType.EU ? (
    <Suspense>
      <HomeContentsEu
        vin={vin}
        puid={puid}
      />
    </Suspense>
  ) : (
    <Suspense>
      <HomeContentsNa vin={vin} />
    </Suspense>
  );
}

export default HomePage;
